import {
  Component,
  ElementRef,
  HostListener,
  inject,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAuthUser } from '../../../features/auth/state/auth.selectors';
import { AsyncPipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { langToCountry } from '../../helpers/lang-utils';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../features/auth/data/services/auth.service';
import { logoutButtonClicked } from '../../../features/auth/state/auth.actions';

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [AsyncPipe, RouterLink, TranslatePipe],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss',
})
export class NavBarComponent {
  @ViewChild('langDropdownRef') langDropdownRef!: ElementRef;
  @ViewChild('userDropdownRef') userDropdownRef!: ElementRef;
  protected isDropdownMenuOpen = false;
  protected isLangDropdownOpen = false;
  protected languages = [
    { code: 'en', label: 'language.en' },
    { code: 'pt', label: 'language.pt' },
    { code: 'es', label: 'language.es' },
    { code: 'it', label: 'language.it' },
  ];
  protected readonly environment = environment;
  private store = inject(Store);
  protected user$ = this.store.select(selectAuthUser);
  private router = inject(Router);
  private translate = inject(TranslateService);
  currentLang = this.translate.currentLang || this.translate.getDefaultLang();
  private authService = inject(AuthService);

  get isAdminRoute() {
    return this.router.url.startsWith('/admin');
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (
      this.langDropdownRef &&
      !this.langDropdownRef.nativeElement.contains(target)
    ) {
      this.isLangDropdownOpen = false;
    }

    if (
      this.userDropdownRef &&
      !this.userDropdownRef.nativeElement.contains(target)
    ) {
      this.isDropdownMenuOpen = false;
    }
  }

  toggleLangDropdown(): void {
    this.isLangDropdownOpen = !this.isLangDropdownOpen;
  }

  getCountryFromLang(lang: string): string {
    return langToCountry[lang] ?? lang;
  }

  switchLang(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('selectedLang', lang);
    this.currentLang = lang;
    this.isLangDropdownOpen = false;
  }

  protected toggleDropdownMenu(event: Event) {
    this.isDropdownMenuOpen = !this.isDropdownMenuOpen;
    this.isLangDropdownOpen = false;
  }

  protected logoutButtonClick() {
    this.store.dispatch(logoutButtonClicked());
  }
}
